import { 
  Component, 
  forwardRef, 
  OnInit, 
  Input,
  ViewEncapsulation, 
  ChangeDetectorRef
} from '@angular/core';
import { 
  ControlValueAccessor, 
  NG_VALUE_ACCESSOR 
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true
  }],
  encapsulation: ViewEncapsulation.None
})
export class InputComponent implements ControlValueAccessor, OnInit {
  @Input() 
  public set value(v : string) {
    this._value = v;
    this.changeDetectorRef.detectChanges();
  }
  private _value: string; 
  @Input() public label: string; 

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
  }
  
  public get value() : string {
    return this._value
  }
  
  public propogateChange = (_: any) => {}

  public propogateTouch = (_: any) => {}
  
  registerOnChange(fn: any) { 
    this.propogateChange = fn;
  }

  registerOnTouched(fn: any){ 
    this.propogateTouch = fn;
  }

  writeValue(value: any) {
    this.value = value;
  }  

  public onChangeValue(value: any) {
    this.propogateTouch(this.value);
    this.value = value;
    this.propogateChange(this.value);
  }

}
